module.exports = __webpack_public_path__ + "static/img/goods_list_more_cell_jifen.75ef8621.png";